import { useEffect, useState } from "react";

export interface PlayCanvasProgress {
  isReady: boolean;
  progress: number; // от 0 до 100
  loaded: number;
  total: number;
}

/**
 * Hook to track PlayCanvas loading progress.
 * Returns loading state with progress percentage and asset counts.
 */
export function usePlayCanvasProgress(): PlayCanvasProgress {
  const [isReady, setIsReady] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const handleProgress = (e: Event) => {
      const customEvent = e as CustomEvent;
      const {
        progress: newProgress,
        loaded: newLoaded,
        total: newTotal,
      } = customEvent.detail;

      setProgress(Math.round(newProgress));
      setLoaded(newLoaded);
      setTotal(newTotal);
    };

    const handlePlayCanvasReady = () => {
      setProgress(100);
      // Небольшая задержка перед скрытием лоадера для плавности
      setTimeout(() => {
        setIsReady(true);
      }, 500);
    };

    window.addEventListener("playcanvas-progress", handleProgress);
    window.addEventListener("playcanvas-ready", handlePlayCanvasReady);

    return () => {
      window.removeEventListener("playcanvas-progress", handleProgress);
      window.removeEventListener("playcanvas-ready", handlePlayCanvasReady);
    };
  }, []);

  return { isReady, progress, loaded, total };
}
